import React from 'react';
import { ThemeProvider } from 'styled-components';
import './App.css';
import GlobalStyle from './styles/global';
import theme from './styles/theme';
import { AuthProvider } from "./contexts/authContext";
import Routes from "./Routes";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap" rel="stylesheet" />
        <GlobalStyle />
        <Routes />
      </AuthProvider>
    </ThemeProvider >
  );
}

export default App;
